import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { BaseApiDataResponse } from '../Models/ApiData';
import {
    CauserieApiDataResponse,
    CauserieListApiDataResponse,
    CauserieOrderBy,
    CauserieResultListApiDataResponse,
} from '../Models/Causerie/Causerie';
import { BaseDataService } from './Base/BaseDataService';

const CauserieEndpoints = {
    CAUSERIES: '/api/v1/back/causeries',
    CREATE_CAUSERIE: '/api/v1/back/causeries',
    CAUSERIE_DETAILS: (causerieId: string) => `/api/v1/back/causeries/${causerieId}`,
    CAUSERIE_PUBLISH: (causerieId: string) => `/api/v1/back/causeries/${causerieId}/is_published`,
    CAUSERIE_DELETE: (causerieId: string) => `/api/v1/back/causeries/${causerieId}`,
    CAUSERIE_RESULT: (causerieId: string) => `/api/v1/back/causeries/${causerieId}/participants`,
};

export interface ICauserieDataService {
    getCauseries: (
        requestParams: { search: string; Count: number; order?: CauserieOrderBy }, // ! TODO Abel Page à supprimer, Count n'est pas un paramètre obligatoire
        cts: XHRRequestCanceler
    ) => Promise<CauserieListApiDataResponse>;

    createCauserie: (
        requestBody: { title: string; description?: string; pdf_id?: string },
        cts: XHRRequestCanceler
    ) => Promise<CauserieApiDataResponse>;

    getCauserieDetails: (
        causerieId: string,
        cts: XHRRequestCanceler
    ) => Promise<CauserieApiDataResponse>;

    updateCauserie: (
        causerie_id: string,
        params: { title: string; description?: string; pdf_id?: string },
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    publishCauserie: (causerie_id: string, cts: XHRRequestCanceler) => Promise<BaseApiDataResponse>;

    deleteCauserie: (causerie_id: string, cts: XHRRequestCanceler) => Promise<BaseApiDataResponse>;

    getCauserieResult: (
        causerie_id: string,
        cts: XHRRequestCanceler
    ) => Promise<CauserieResultListApiDataResponse>;
}

class CauserieDataService extends BaseDataService implements ICauserieDataService {
    public getCauseries = (
        params: { search: string; Count: number; order?: CauserieOrderBy },
        cts: XHRRequestCanceler
    ) => {
        return this.get<CauserieListApiDataResponse>(CauserieEndpoints.CAUSERIES, cts, { params });
    };

    public createCauserie = (
        requestBody: { title: string; description?: string; pdf_id?: string },
        cts: XHRRequestCanceler
    ): Promise<CauserieApiDataResponse> => {
        return this.post(CauserieEndpoints.CREATE_CAUSERIE, requestBody, cts);
    };

    public getCauserieDetails = async (
        causerieId: string,
        cts: XHRRequestCanceler
    ): Promise<CauserieApiDataResponse> => {
        return this.get(CauserieEndpoints.CAUSERIE_DETAILS(causerieId), cts);
    };

    public updateCauserie = (
        causerie_id: string,
        body: { title: string; description?: string; pdf_id?: string },
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return this.patch(CauserieEndpoints.CAUSERIE_DETAILS(causerie_id), body, cts);
    };

    public publishCauserie = async (
        causerie_id: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return this.patch(
            CauserieEndpoints.CAUSERIE_PUBLISH(causerie_id),
            { set_published: true },
            cts
        );
    };

    public deleteCauserie = async (
        causerie_id: string,
        cts: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        return this.delete(CauserieEndpoints.CAUSERIE_DELETE(causerie_id), cts);
    };

    public getCauserieResult = async (
        causerie_id: string,
        cts: XHRRequestCanceler
    ): Promise<CauserieResultListApiDataResponse> => {
        return this.get(CauserieEndpoints.CAUSERIE_RESULT(causerie_id), cts);
    };
}

const CauserieDataServiceName = 'CauserieDataService';
export { CauserieDataService, CauserieDataServiceName };
